export default __webpack_public_path__ + "static/media/tagme1.8a41a3a0.jpg";